<div class="popup-container p-3">
  <h2 class="message">
    {{'We strongly recommend that you allow us to send you information by email or whatsapp. Only then you can be sure not to miss any important dates, deadlines or other important news in the future'|translate}}
  </h2>
  <div class="d-flex w-100 justify-content-center">
    <button (click)="closeDialog(true)" class="btn-primary-yes"   mat-raised-button>{{'Back'|translate}}</button>
    <button (click)="closeDialog(false)" class="btn-secondary-no" mat-raised-button routerLink="/secure/register">{{'Continue'|translate}}</button>
  </div>
</div>
